import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  config: any;
  constructor(private injector: Injector) { }

  load(url: string) {
    const injectHttp = this.injector.get(HttpClient);
    return new Promise((resolve) => {
      injectHttp.get(url).pipe(
        map(res => res),
        tap(response => Object.assign(environment, response))
      ).subscribe(config => {
        this.config = config;
        resolve(true);
      });
    });
  }

  getConfiguration(element: string, dataList?: string, includeBar: boolean = false) {
    let urlWithElement;
    if (!dataList) {
      urlWithElement = environment[element];
    } else {
      urlWithElement = environment[dataList][element];
    }
    return urlWithElement;
  }

  getEndPoint(elementUrl: string, elementPath: string) {
    let url = environment['API_URLS'][elementUrl];
    let path = environment['PATHS'][elementPath];

    // Remove trailing slash from url if present
    if (url.endsWith('/')) {
      url = url.slice(0, -1);
    }
    // Remove leading slash from path if present
    if (path.startsWith('/')) {
      path = path.slice(1);
    }
    return url + '/' + path;
  }

  getUrl(element: string, dataList?: string) {
    if (!dataList) {
      const urlWithElement = environment[element];
      return urlWithElement;
    } else {
      const urlWithDataList = environment[dataList][element];
      return urlWithDataList;
    }
  }

  verifyUrl(typeModel: any): string {
    if (typeModel) {
      if (typeModel.includes('/', typeModel.length - 1)) {
        const typeRelease = typeModel;
        return typeRelease;
      } else {
        const newType = typeModel + '/';
        return newType;
      }
    }
    return '/';
  }
}
